// external libs
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

import { extendTemplateVariables } from '../InputHelpFunctions'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  clearQuoteInputHelps: null,
  defaultTemplateVariablesRequestSuccess: ['defaultTemplateVariables', 'inObject'],
  productInputHelpsMerge: ['specificInputHelps'],
  discountsInputHelpsMerge: ['specificInputHelps'],
  calculatorInputHelpsMerge: ['specificInputHelps'],
  quoteInputHelpsMerge: ['quoteId', 'specificInputHelps'],
  quoteInputHelpsRemove: ['quoteId'],
  quoteInputHelpsRefresh: ['oldID', 'newID', 'newSpecificInputHelps']
})

export const InputHelpsTypes = Types
export default Creators

/* ------------- Types and Action Creators ------------- */

export const prepareInputHelps = inputHelps => {
  return Object.keys(inputHelps).reduce((acc, inputHelpKey) => {
    if (typeof inputHelps[inputHelpKey] === 'string') {
      acc[inputHelpKey] = { content: inputHelps[inputHelpKey] }
    } else if (inputHelps[inputHelpKey].content) {
      acc[inputHelpKey] = inputHelps[inputHelpKey]
    } else {
      acc[inputHelpKey] = prepareInputHelps(inputHelps[inputHelpKey])
    }
    return acc
  }, {})
}

export const mergeInputHelps = (specificInputHelps, defaultInputHelps) =>
  Object.assign(defaultInputHelps, specificInputHelps)

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({ // eslint-disable-line
  productInputHelps: {},
  calculatorInputHelps: {},
  quotesInputHelps: {},
  discountsInputHelps: {},
  defaultTemplateVariables: extendTemplateVariables({}),
})

/* ------------- Reducers ------------- */

export const clearQuoteInputHelpsR = state =>
  state.merge({ quotesInputHelps: INITIAL_STATE.quotesInputHelps })

export const quoteInputHelpsMergeR = (state, { quoteId, specificInputHelps }) =>
  state.setIn(['quotesInputHelps', quoteId], mergeInputHelps(prepareInputHelps(specificInputHelps), state.productInputHelps.asMutable()))

export const quoteInputHelpsRemoveR = (state, { quoteId }) => {
  const quotesInputHelps = state.quotesInputHelps.asMutable()
  delete quotesInputHelps[quoteId]
  return state.merge({ quotesInputHelps })
}

export const quoteInputHelpsRefreshR = (state, { oldID, newID, newSpecificInputHelps }) => {
  const quotesInputHelps = state.quotesInputHelps.asMutable()
  quotesInputHelps[newID] = mergeInputHelps(prepareInputHelps(newSpecificInputHelps), state.productInputHelps.asMutable())
  delete quotesInputHelps[oldID]
  return state.merge({ quotesInputHelps })
}

export const productInputHelpsMergeR = (state, { specificInputHelps }) => {
  const productInputHelps = prepareInputHelps(specificInputHelps)
  return state.merge({
    productInputHelps,
    calculatorInputHelps: productInputHelps,
  })
}

export const calculatorInputHelpsMergeR = (state, { specificInputHelps }) =>
  state.merge({ calculatorInputHelps: mergeInputHelps(prepareInputHelps(specificInputHelps), state.productInputHelps.asMutable()) })

export const discountsInputHelpsMergeR = (state, { specificInputHelps }) => {
  return state.merge({ discountsInputHelps: mergeInputHelps(prepareInputHelps(specificInputHelps), state.discountsInputHelps.asMutable()) })
}

export const defaultTemplateVariablesRequestSuccessR = (state, { defaultTemplateVariables, inObject }) =>
  state.set('defaultTemplateVariables', extendTemplateVariables({})).setIn(['defaultTemplateVariables', inObject], defaultTemplateVariables)

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.QUOTE_INPUT_HELPS_MERGE]: quoteInputHelpsMergeR,
  [Types.QUOTE_INPUT_HELPS_REMOVE]: quoteInputHelpsRemoveR,
  [Types.QUOTE_INPUT_HELPS_REFRESH]: quoteInputHelpsRefreshR,
  [Types.CLEAR_QUOTE_INPUT_HELPS]: clearQuoteInputHelpsR,
  [Types.PRODUCT_INPUT_HELPS_MERGE]: productInputHelpsMergeR,
  [Types.DISCOUNTS_INPUT_HELPS_MERGE]: discountsInputHelpsMergeR,
  [Types.CALCULATOR_INPUT_HELPS_MERGE]: calculatorInputHelpsMergeR,
  [Types.DEFAULT_TEMPLATE_VARIABLES_REQUEST_SUCCESS]: defaultTemplateVariablesRequestSuccessR,
})
